<template>
  <div class="account-dropdown-list">
    <div class="account-dropdown-list__triangle">
      <up-triangle></up-triangle>
    </div>
    <div class="account-dropdown-list__header account-dropdown-list-header">
      <p class="account-dropdown-list-header__label">
        Your account
        <span
          v-if="!authStore.isMaster"
          class="account-dropdown-list-header__label-sub"
        >
          Child
        </span>
      </p>
      <p class="account-dropdown-list-header__email">
        {{ authStore.userEmail }}
      </p>
    </div>
    <ul class="account-dropdown-list-items">
      <li
        v-for="item in menuStore.dropdownNavigation"
        :key="item.id"
        class="account-dropdown-list-items__item"
      >
        <router-link
          v-if="!item.isButton"
          :to="{ name: item.to }"
          class="account-dropdown-list-items__link"
          ><span class="account-dropdown-list-items__link--icon">
            <component :is="item.icon"></component>
          </span>
          {{ item.label }}</router-link
        >

        <button
          v-if="item.isButton"
          @click.prevent="onButtonClick(item)"
          :disabled="loading"
          class="account-dropdown-list-items__link"
        >
          <span class="account-dropdown-list-items__link--icon">
            <component :is="item.icon"></component>
          </span>
          {{ item.label }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup>
import UpTriangle from '@/assets/svg/upTriangle.svg?component'

import { useAuthStore } from '@/stores/auth'
import { useMenuStore } from '@/stores/menu'
import { useRoute, useRouter } from 'vue-router'
import { getUserData } from '@core/auth/utils'
import { startOrder } from '@core/composables/order/startOrder'
import { OrderTypes } from '@modules/app-steps/step-two/tabs/tabs-data'

const authStore = useAuthStore()
const menuStore = useMenuStore()
const route = useRoute()
const router = useRouter()
const { executeStartOrder } = startOrder()

const onLogOut = () => authStore.logout(route)

const handleMiscPurchase = async () => {
  const { firstName, lastName, phone } = getUserData()

  const order = await executeStartOrder({
    firstName,
    lastName,
    phone,
    orderType: OrderTypes.MiscSale,
  })

  const orderId = order?.value?.id
  if (!orderId) return

  router.push({ name: 'order-misc-sale', params: { id: orderId } })
}

const onButtonClick = async (item) => {
  if (!item.action) return
  if (item.action === 'logout') return onLogOut()
  if (item.action === 'miscPurchase') return handleMiscPurchase()
}
</script>
